import * as XLSX from 'xlsx'

export default function generateExcelBoqsProblems(problems) {
  const rows = problems.map(item => ({
    BimLink: item.bimLinkCode ?? '-',
    Grupo: item.issue.groupName ?? '-',
    Nombre: item.name ?? '-',
    ElementId: item.elementId ?? '-',
    'Problema sobre': item.issue.type ?? '-',
    'Tipo problema':
      item.issue.issue?.substring(0, item.issue.issue?.indexOf('|')) ?? '-',
    Problema:
      item.issue.issue?.substring(item.issue.issue?.indexOf('|') + 1) ?? '-',
  }))

  // ----------- Hoja 1: Detalle -------------
  const worksheet1 = XLSX.utils.json_to_sheet(rows)
  worksheet1['!cols'] = [
    { wch: 30 },
    { wch: 30 },
    { wch: 30 },
    { wch: 20 },
    { wch: 25 },
    { wch: 50 },
    { wch: 100 },
  ]
  worksheet1['!autofilter'] = { ref: `A1:G${rows.length + 1}` }

  // ----------- Hoja 2: Resumen (valores únicos agrupados) -------------

  // Usamos un Set para evitar duplicados
  const resumenMap = new Map()

  for (const item of rows) {
    const keyParts = [
      item.BimLink,
      item.Grupo,
      item['Problema sobre'],
      item['Tipo problema'],
      item.Problema,
    ]
    const key = keyParts.join('|')

    if (!resumenMap.has(key)) {
      resumenMap.set(key, {
        BimLink: item.BimLink,
        Grupo: item.Grupo,
        'Problema sobre': item['Problema sobre'],
        'Tipo problema': item['Tipo problema'],
        Problema: item.Problema,
        elementosSet: new Set(),
      })
    }

    if (item.ElementId && item.ElementId !== '-') {
      resumenMap.get(key).elementosSet.add(item.ElementId)
    }
  }

  // Construimos el resumen con el conteo final
  const resumen = Array.from(resumenMap.values()).map(item => ({
    BimLink: item.BimLink,
    Grupo: item.Grupo,
    'Problema sobre': item['Problema sobre'],
    'Tipo problema': item['Tipo problema'],
    Problema: item.Problema,
    'Numero de elementos': item.elementosSet.size,
  }))

  const worksheet2 = XLSX.utils.json_to_sheet(resumen)
  worksheet2['!cols'] = [
    { wch: 30 },
    { wch: 30 },
    { wch: 25 },
    { wch: 50 },
    { wch: 100 },
  ]

  worksheet2['!autofilter'] = { ref: `A1:E${resumen.length + 1}` }

  // ----------- Generar archivo Excel -------------
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet2, 'Resumen Problemas BOQ')
  XLSX.utils.book_append_sheet(
    workbook,
    worksheet1,
    'Problemas BOQ por elemento '
  )

  XLSX.writeFile(workbook, 'boq_problems.xlsx')
}
